import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

export default function useUsers() {
  const refUserListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: false, thAttr: { width: '30' } },
    { key: 'full_name', sortable: false, label: 'Họ tên' },
    { key: 'username', sortable: false, label: 'Tên đăng nhập' },
    { key: 'email', sortable: false },
    {
      key: 'role',
      sortable: false,
      label: 'Vai trò',
    },
    { key: 'status', sortable: false, label: 'Trạng thái' },
    { key: 'actions', label: 'Hành động', thAttr: { width: '200' } },
  ];
  const loading = ref(false);
  const perPage = ref(10);
  const totalEntries = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const roleFilter = ref(null);
  const planFilter = ref(null);
  const statusFilter = ref(null);
  const isPaginate = ref(1);
  const roleOptions = ref([]);
  const itemsData = ref([]);

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalEntries.value,
    };
  });
  const fetchUsers = () => {
    loading.value = true;
    store
      .dispatch('users/fetchUsers', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        plan: planFilter.value,
        status: statusFilter.value,
        isPaginate: isPaginate.value,
      })
      .then((response) => {
        if (response.status === 200) {
          const users = response.data.data.data;
          const { total } = response.data.data;

          itemsData.value = users;
          totalEntries.value = total;
          loading.value = false;
        }
      });
  };
  const fetchPositions = (callback) => {
    store.dispatch('users/fetchPositions', {}).then((response) => {
      if (response.status === 200) {
        const positions = response.data.data;
        callback(positions);
      }
    });
  };
  const fetchDepartments = (callback) => {
    store
      .dispatch('users/fetchDepartments', {
        isPaginate: 0,
      })
      .then((response) => {
        if (response.status === 200) {
          const departments = response.data.data;
          callback(departments);
        }
      });
  };
  const fetchRoles = () => {
    store
      .dispatch('users/fetchRoles', {
        isPaginate: 0,
      })
      .then((response) => {
        if (response.status === 200) {
          roleOptions.value = response.data;
        }
      });
  };

  const refetchData = () => {
    fetchUsers();
  };

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData();
  });

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const statusOptions = [
    { label: 'Đợi duyệt', id: 2 },
    { label: 'Đã kích hoạt', id: 1 },
    { label: 'Chưa kích hoạt', id: 0 },
  ];
  const genderOptions = [
    { label: 'Nam', id: 1 },
    { label: 'Nữ', id: 2 },
    { label: 'Chưa xác định', id: 3 },
  ];
  const resolveUserRoleVariant = (role) => {
    if (role === 'subscriber') return 'primary';
    if (role === 'author') return 'warning';
    if (role === 'maintainer') return 'success';
    if (role === 'editor') return 'info';
    if (role === 'admin') return 'danger';
    return 'primary';
  };

  const resolveUserRoleIcon = (role) => {
    if (role === 'subscriber') return 'UserIcon';
    if (role === 'author') return 'SettingsIcon';
    if (role === 'maintainer') return 'DatabaseIcon';
    if (role === 'editor') return 'Edit2Icon';
    if (role === 'admin') return 'ServerIcon';
    return 'UserIcon';
  };

  const resolveUserStatusVariant = (status) => {
    if (status === 2) return 'warning';
    if (status === 1) return 'success';
    if (status === 0) return 'secondary';
    return 'primary';
  };
  const resolveUserRoleName = (roleNames) => roleNames.split(',');
  const resolveUserStatusText = (status) => {
    const item = statusOptions.find((x) => x.id === status);
    return item ? item.label : '';
  };
  const resolveUserGenderText = (gender) => {
    const item = genderOptions.filter((x) => x.id === gender);
    return item ? item.label : '';
  };

  return {
    roleOptions,
    itemsData,
    loading,
    fetchUsers,
    fetchPositions,
    fetchDepartments,
    fetchRoles,
    tableColumns,
    perPage,
    currentPage,
    totalEntries,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    resolveUserStatusText,
    resolveUserGenderText,
    resolveUserRoleName,
    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
    statusOptions,
    genderOptions,
  };
}
